/**
 * Chart Timeframes and Favorites Management.
 *
 * Provides canonical timeframe definitions and favorite list mutations.
 */

export const TIMEFRAMES = [
  "1m",
  "2m",
  "3m",
  "5m",
  "15m",
  "30m",
  "1h",
  "D",
] as const;

export type Timeframe = typeof TIMEFRAMES[number];

/**
 * Checks if a timeframe code is supported by the chart engine.
 */
export function isValidTimeframe(tf: string): boolean {
  return (TIMEFRAMES as readonly string[]).includes(tf);
}

/**
 * Toggles a timeframe code within a favorites list, optionally capping list length.
 */
export function toggleFavoriteTimeframe(
  favorites: string[],
  tf: string,
  maxFavorites?: number,
): string[] {
  const current = Array.isArray(favorites) ? [...favorites] : [];
  const idx = current.indexOf(tf);
  if (idx >= 0) {
    current.splice(idx, 1);
  } else {
    if (maxFavorites && current.length >= maxFavorites) {
      current.pop();
    }
    current.push(tf);
  }
  return current;
}
